<script setup>
defineProps({
  logo: {
    type: Object,
    default: () => {},
  },
});
</script>

<template>
  <div v-if="logo?.src" class="header__logo">
    <Logo
      :src="logo?.src"
      :alt="logo?.alt"
      :height="logo?.height"
      :width="logo?.width"
    />
  </div>
</template>
<style scoped lang="scss">
.header {
  &__logo {
    align-self: end;
    display: flex;
    justify-content: center;
    &:deep(.logo__image) {
      height: 40px;
      width: auto;
      @include media-breakpoint-up(sm) {
        height: 64px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(height, 64);
      }
    }
  }
}
</style>
